export default (node) => {
    const searchInput = node.querySelector(".search_input");
    const searchBox = node.querySelector(".search__box");
    const searchBoxInput = node.querySelector(".search__box__input");
    const searchBoxSelects = node.querySelectorAll(".search__box__select");
    const searchBoxSubmit = node.querySelector(".search__box__submit");
    const filters = node.querySelectorAll('.filter button, .filter label, .filter input');
    const search = node.querySelector(".search_btn");
    let closeSearchBoxId;


    const onSearchFocus = (event) => {
        // node.classList.add("search-opened");
        searchBoxInput.focus();
    }

    const onSearchClick = (event) => {
        if(node.closest(".search-opened")) {
            // closeSearchBox();
        } else {
            let refSearchOpenedSelector = node.dataset.refSearchOpenedSelector;
            if(refSearchOpenedSelector) {
                refSearchOpenedSelector = document.querySelector(refSearchOpenedSelector);
            } else {
                refSearchOpenedSelector = node;
            }
            searchBox.style.display = "block";
            setTimeout(function() {
                refSearchOpenedSelector.classList.add("search-opened");
                refSearchOpenedSelector.classList.remove("opened");
            }, 0);
            onSearchFocus();
            search.setAttribute("aria-expanded", true);
            searchInput.setAttribute("aria-expanded", true);
        }
    };

    const closeSearchBox = () => {
        let refSearchOpenedSelector = node.dataset.refSearchOpenedSelector;
        let delay = 0;
        search.classList.remove('active');
        if(refSearchOpenedSelector) {
            if(window.innerWidth < 768) {
                delay = 300;
            }
            refSearchOpenedSelector = document.querySelector(refSearchOpenedSelector);
        } else {
            refSearchOpenedSelector = node;
        }
        refSearchOpenedSelector.classList.remove("search-opened");
        
        setTimeout(function() {
            searchBox.style.display = "none";
        }, delay);
        search.setAttribute("aria-expanded", false);
        searchInput.setAttribute("aria-expanded", false);
    }

    const onSearchBoxFocus = (item = 0) => {
        clearTimeout(closeSearchBoxId);
    };

    const onSearchBoxBlur = (item = 0) => {
        closeSearchBoxId = setTimeout(closeSearchBox, 10);
    };

    const addListeners = () => {
        //search.addEventListener("click", onSearchClick);
        search.onclick = () => {
           // alert(search.classList.contains('active'));
            if(!search.classList.contains('active')){
                search.classList.add('active');
                onSearchClick();
            }else{
                
            }
        }
        searchInput.addEventListener("click", onSearchClick);
        // searchInput.addEventListener("focus", onSearchFocus);
        searchBoxSelects.forEach((item) => {
            item.addEventListener("focus", onSearchBoxFocus);
            item.addEventListener("blur", onSearchBoxBlur);
        });
        [search, searchBoxInput, searchBoxSubmit, ...filters].forEach((item) => {
            item.addEventListener("blur", () => {
                onSearchBoxBlur(item)
            });
            
            item.addEventListener("focus", () => {
                onSearchBoxFocus(item)
            });
        });
    };

    addListeners();
};
